import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosInstance } from '../../shared/api/axiosInstance';

interface AuthState {
    token: string | null;
    loading: boolean;
    error: string | null;
}

const initialState: AuthState = {
    token: null,
    loading: false,
    error: null,
};


export const fetchTempToken = createAsyncThunk<
    string,
    void,
    { rejectValue: string }
>(
    'auth/fetchTempToken',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/auth/temp/token');

            const { data } = response.data;
            console.log(response.data)
            return data.access_token;
        } catch (error: any) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data.message || 'Failed to fetch token');
            }
            return rejectWithValue('An unexpected error occurred');
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<AuthState['token']>) => {
            state.token = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTempToken.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTempToken.fulfilled, (state, action: PayloadAction<string>) => {
                state.loading = false;
                state.token = action.payload;
            })
            .addCase(fetchTempToken.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch token';
            });
    },
});
export const {setToken}=authSlice.actions
export default authSlice.reducer;
